import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Button, Container } from "./index.styled";
import { useCallback, useEffect } from "react";

const EVENT_TYPE = 'keydown';
const LEFT_ARROW_KEY_CODE = 37;
const RIGHT_ARROW_KEY_CODE = 39;

interface SliderProps {
    onPrev: () => void;
    onNext: () => void;
    showPrev: boolean;
    showNext: boolean;
    disableKeyboard?: boolean;
}
const Slider: React.FC<SliderProps> = ({ onPrev, onNext, showPrev, showNext, disableKeyboard, children }) => {

    const handleKeyPressed = useCallback((event) => {
        if (showPrev && !disableKeyboard && event.keyCode === LEFT_ARROW_KEY_CODE) {
            onPrev();
        }
        if (showNext && !disableKeyboard && event.keyCode === RIGHT_ARROW_KEY_CODE) {
            onNext();
        }
    }, [showPrev, onPrev, onNext, showNext, disableKeyboard]);

    useEffect(() => {
        document.addEventListener(EVENT_TYPE, handleKeyPressed, false);
        return () => {
            document.removeEventListener(EVENT_TYPE, handleKeyPressed, false);
        };
    }, [handleKeyPressed]);

    return (
        <Container>
            <Button show={showPrev} onClick={onPrev}>
                <FaChevronLeft />
            </Button>
            {children}
            <Button show={showNext} onClick={onNext}>
                <FaChevronRight />
            </Button>
        </Container>
    );
}

export default Slider;